import * as rootSelectors from '../../selectors/root';
import { createSelector } from 'reselect';
import { generic } from '../../helpers/firebaseTransformations';
import {
    selectActiveDiscoverId,
    selectActiveDiscoverLocation,
    selectActiveDiscoverParentList,
} from '../../redux/ui/uiSelectors';
import { selectSitePages } from '../../redux/usersSelectors';
import { transformObjectToArray } from '../../helpers/firebaseTransformations';
import _ from 'lodash';

export const selectDiscover = createSelector(
    state => state.discover,
    discover => discover || [],
);
export const selectDiscoverTop = createSelector(
    state => state.discover,
    discover => discover.top || [],
);
export const selectDiscoverOther = createSelector(
    state => state.discover,
    discover => discover.other || [],
);

export const selectOrderedDiscoverTopArray = createSelector(
    //Returns array of ordered
    selectDiscoverTop,
    discoverTop =>
        generic(discoverTop)
            .map(obj => {
                obj.location = 'top';
                return obj;
            })
            .sort((a, b) => a.index - b.index) || [],
);

export const makeNextDiscoverIndexNumber = createSelector(
    [selectOrderedDiscoverTopArray],
    top => top.length,
);

export const selectOrderedDiscoverOtherArray = createSelector(
    selectDiscoverOther,
    discoverOther =>
        generic(discoverOther).map(obj => {
            obj.location = 'other';
            return obj;
        }),
);

export const makeSitePagesOptions = createSelector(
    [selectSitePages],
    sitePages => {
        return sitePages.map(sitePage => {
            return {
                value: sitePage.id,
                label: sitePage.attributes.name,
            };
        });
    },
);

//Preps data to be used with ads or document manager for Info type card
const modifyRichFileNodes = node => {
    let nextNode;
    if (_.get(node, 'content.documents')) {
        //Create categories uploaded, toRemove and toUpload and put existing documents in uploaded
        nextNode = _.cloneDeep(node);
        nextNode = {
            ...nextNode,
            content: {
                ...nextNode.content,
                documents: { uploaded: transformObjectToArray(nextNode.content.documents), toRemove: [], toUpload: [] },
            },
        };
        return nextNode;
    }  else if (_.get(node, 'content.ads')) {
        //Create categories uploaded, toRemove and toUpload and put existing documents in uploaded
        nextNode = _.cloneDeep(node);
        nextNode = {
            ...nextNode,
            content: {
                ...nextNode.content,
                ads: { uploaded: transformObjectToArray(nextNode.content.ads), toRemove: [], toUpload: [] },
            },
        };
        return nextNode;
    }
    else {
        return node;
    }
};

export const makeActiveDiscover = createSelector(
    [
        rootSelectors.getResetDocumentsToUpload,
        selectActiveDiscoverId,
        selectActiveDiscoverLocation,
        selectActiveDiscoverParentList,
        selectDiscover,
    ],
    (resetDocumentsToUpload, id, location, parent_list, discover) => {
        if (id && location && discover && discover[location]) {
            return parent_list
                ? discover[location][parent_list]
                    ? modifyRichFileNodes(discover[location][parent_list][id])
                    : undefined
                : modifyRichFileNodes(discover[location][id]);
        } else {
            return undefined;
        }
    },
);
